import { render } from "./profileImage.vue?vue&type=template&id=23f6553a&scoped=true"
import script from "./profileImage.vue?vue&type=script&lang=js"
export * from "./profileImage.vue?vue&type=script&lang=js"

import "./profileImage.vue?vue&type=style&index=0&id=23f6553a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f6553a"]])

export default __exports__